import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { AddAddressComponent } from './add-address/add-address.component';
import { AddCreditCardComponent } from './add-credit-card/add-credit-card.component';
import { Router } from '@angular/router';
import { OrdersService } from 'src/app/services/orders.service';
import { UserService } from 'src/app/services/user.service';
import { EditAddressComponent } from './edit-address/edit-address.component';
import { Subscription } from 'rxjs';
import { CardService } from 'src/app/services/card.service';
import { DialogEditDeliveryDatesComponent } from '../dialogs/dialog-edit-delivery-dates/dialog-edit-delivery-dates.component';
import { DialogUpdateSingleDeliveryDateComponent } from '../dialogs/dialog-update-single-delivery-date/dialog-update-single-delivery-date.component';

import { LoginComponent } from '../auth/login/login.component';

declare var $: any;
declare var WebxpayTokenizeInit: any;

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.css']
})
export class ProfileSettingsComponent implements OnInit, OnDestroy {

  currentOrders: [];
  currentOrderCount = '';
  addresses = [];
  cards;
  address;
  user;
  ordersEmpty = false;

  addressesSub: Subscription;
  cardsSub: Subscription;
  currentOrdersSub: Subscription;

  constructor(private ordersService: OrdersService, private userService: UserService, private cardService: CardService, private router: Router, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user.userType !== 'User') {
      this.router.navigate(['/']);
      this.dialog.open(LoginComponent);
      this.snackBar.open('Please log in to view this page', 'Dismiss', {
        duration: 3000
      });
    }

    const data = new FormData;
    data.append('status', 'Pending');

    this.ordersService.getAllOrders(data).subscribe(result => {
      this.currentOrders = result.data;
      this.currentOrderCount = result.data.length || 0;
    }, error => {
      this.ordersEmpty = true;
    });

    this.currentOrdersSub = this.ordersService.getOrdersUpdated().subscribe(result => {
      this.currentOrders = result;
      this.currentOrderCount = result.length || 0;
    })

    const localUser = localStorage.getItem('user');
    this.user = JSON.parse(localUser);
    this.cards = this.user.cards;

    this.addressesSub = this.userService.getAddresses().subscribe(result => {
      this.addresses = result;
    });

    this.cardsSub = this.cardService.getCards().subscribe(result => {
      this.cards = result;
    });

    this.userService.getMe().subscribe(result => {
      if (result.success) {
        this.addresses = result.data.addresses;
        this.cardService.setCards(result.data.cards);
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onAddNewOrder() {
    this.router.navigate(['/']);
  }

  onDeleteAddress(ID) {

    const data = new FormData();
    data.append('_id', ID);

    this.userService.deleteAddress(data).subscribe(result => {
      if (result.success) {
        this.addresses = result.data.addresses;

        this.snackBar.open('Address successfully deleted.', 'Dismiss', {
          duration: 3000
        });

        const localUser = localStorage.getItem('user');
        this.user = JSON.parse(localUser);

        this.user.addresses = this.addresses;
        const stringyUser = JSON.stringify(this.user);
        localStorage.setItem('user', stringyUser);
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onAddAddressClick() {
    this.dialog.open(AddAddressComponent);
  }

  onAddCreditCard() {
    this.dialog.open(AddCreditCardComponent);
  }

  onEditAddress(ID) {
    let addressToBeEdited;

    this.addresses.map(address => {
      if (address._id === ID) {
        address.mobile = address.mobile.toString().split('94')[1];
        addressToBeEdited = address
      }
    });

    this.dialog.open(EditAddressComponent, {
      data: {
        address: addressToBeEdited
      }
    });
  }

  onRemoveCard(card: string) {
    this.cardService.removeCard(card).subscribe(result => {
      if (result.success) {

        const localUser = localStorage.getItem('user');
        const user = JSON.parse(localUser);
        user.cards = result.data;

        const userString = JSON.stringify(user);

        localStorage.setItem('user', userString);
        this.cardService.setCards(user.cards);

        this.dialog.closeAll();
        this.snackBar.open('Card successfully removed', 'Dismiss', {
          duration: 3000
        });

        this.cardService.setCards(result.data);
      }
    });
  }

  onCalcelSubscription(ID: string) {
    const data = new FormData();
    data.append('_id', ID);

    const filter = new FormData;
    filter.append('status', 'Pending');

    this.ordersService.cancelOrder(data).subscribe(result => {
      if (result.success) {
        this.ordersService.getAllOrders(filter).subscribe(result => {
          this.currentOrders = result.data;
          this.currentOrderCount = result.data.length || 0;
        }, error => {
          this.ordersEmpty = true;
          this.snackBar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    });
  }

  onEditDeliveryDates(ID: string, deliveries: any) {
    this.dialog.open(DialogEditDeliveryDatesComponent, {
      data: {
        _id: ID,
        deliveries: deliveries
      },
      maxWidth: '600px'
    });
  }

  onEditSingleDelviery(DeliveryID: string, DeliveryDate: string) {
    this.dialog.open(DialogUpdateSingleDeliveryDateComponent, {
      data: {
        deliveryID: DeliveryID,
        deliveryDate: DeliveryDate
      },
      maxWidth: '300px'
    });
  }

  ngOnDestroy() {
    this.addressesSub.unsubscribe();
    this.cardsSub.unsubscribe();
    this.currentOrdersSub.unsubscribe();
  }
}
